/* ---------------------------------------

    -- 要素の表示、非表示を管理

--------------------------------------- */
export default class Contents {
    constructor(scroll) {

        this.manager = scroll;

        this.$point //アニメーションするセンテンス保存
        this.$pointShow //アニメーション対象保存

        this.$navi
        this.$naviPoint //表示中エリア

        this.$scrollDown
        this.$copyright
        this.$pageTop



        this.status = {
            current: 0, //表示中のセンテンス
            pagetop: false,
            naviCurrent:0,
            naviPrevCurrent:0
        }

        this.motSt = [] //アニメーションに関するものを定義
        this.point = [] //ナビゲーション切り替えるポイント保存

        this.kv = {
            flg: false,
            point: 0,
            show: true,
        }
        this.sns = true;
        this.endPoint = 0

    }
    init(pageID) {
        this.$point = document.querySelectorAll('.js__sc-point')
        this.$pointShow = document.querySelectorAll('.js__sc-point-show')
        this.$scrollDown = document.querySelector('.scroll-down')
        this.$copyright = document.querySelector('.row-copy')
        this.$pageTop = document.getElementById('c-pageTop')

        // TweenMax.set(this.$pageTop, {
        //     opacity: 0,
        //     y: 20,
        // })

        //this.$naviPoint


        this.$navi = document.querySelectorAll(".header-nav__item a")
        this.$naviPoint = document.querySelectorAll(".js__sc-nav")

        for (let i in this.$naviPoint) {
            if (this.$naviPoint[i].nodeType != 1) break

            let _rect = this.$naviPoint[i].getBoundingClientRect()

            this.point[i] = {
                base: _rect.top,
                start: Math.max(_rect.top - window.innerHeight, i * 10),
                end: Math.max(_rect.top + _rect.height + window.innerHeight / 2, window.innerHeight),
            }
        }

        for (let i in this.$point) {
            if (this.$point[i].nodeType != 1) break

            this.motSt[i] = {
                show: false,
                //全部保存
                $target: this.$point[i].querySelectorAll('.js__sc-point-show'),
                //タイプごとに保存
                $scale: [],
                $panel: [],
                $split: [],
                $fade: [],
                //アニメーションを入れておく
                func: false,
                //位置情報を定義
                posi: {
                    base: 0,
                    start: 0,
                    end: 0,
                },
            }

            let _count = {
                scale: 0,
                panel: 0,
                split: 0,
                fade: 0,
            }

            // 含まれるアニメーション要素を確認
            for (let j in this.motSt[i].$target) {
                if (this.motSt[i].$target[j].nodeType != 1) break
                const _classList = this.motSt[i].$target[j]
                    .getAttribute('class')
                    .split(' ')

                if (_classList.indexOf('js__scale') >= 0) {
                    this.motSt[i].$scale[_count.scale] = this.motSt[i].$target[
                        j
                    ]
                    _count.scale += 1
                } else if (_classList.indexOf('js__panel') >= 0) {
                    this.motSt[i].$panel[_count.panel] = this.motSt[i].$target[
                        j
                    ]
                    _count.panel += 1
                } else if (_classList.indexOf('js__split') >= 0) {
                    this.motSt[i].$split[_count.split] = this.motSt[i].$target[
                        j
                    ]
                    _count.split += 1
                } else if (_classList.indexOf('js__fade') >= 0) {
                    this.motSt[i].$fade[_count.fade] = this.motSt[i].$target[j]
                    _count.fade += 1
                }
            }

            //必要アニメーションを定義

            setTimeout(() => {

                if (this.motSt[i].$scale[0]) {
                    TweenMax.set(this.motSt[i].$scale, {
                        scale: 1.04,
                        opacity: 0,
                    })
                }

                if (this.motSt[i].$split[0])
                    this.effect.split(this.motSt[i].$split, 'set')

                if (this.motSt[i].$panel[0]){
                    for (let j in this.motSt[i].$panel) {
                        TweenMax.set(this.motSt[i].$panel[j], {
                            scale: 0.94,
                        })
                        TweenMax.set(this.motSt[i].$panel[j].querySelector('.js__panel__inner'), {
                            scale: 1.15,
                            opacity: 0
                        })
                    }
                }

                if (this.motSt[i].$fade[0]) {
                    TweenMax.set(this.motSt[i].$fade, {
                        opacity: 0,
                    })
                }

                this.motSt[i].func = () => {

                    if (this.motSt[i].$scale[0]) {
                        for (let j in this.motSt[i].$scale) {
                            let _delay = this.motSt[i].$scale[j].getAttribute('data-delay');
                            TweenMax.to(
                                this.motSt[i].$scale[j],
                                1.6,
                                {
                                    delay: _delay,
                                    scale: 1,
                                    ease: Power2.easeOut,
                                }
                            )
                            TweenMax.to(
                                this.motSt[i].$scale[j],
                                0.8,
                                {
                                    delay: _delay,
                                    opacity: 1,
                                    ease: Power2.easeOut,
                                }
                            )
                        }
                    }
                    if (this.motSt[i].$panel[0]) {
                        for (let j in this.motSt[i].$panel) {
                            TweenMax.to(
                                this.motSt[i].$panel[j],
                                1.6,
                                {
                                    scale: 1,
                                    ease: Power2.easeOut,
                                    delay: 0.3,
                                }
                            )
                            TweenMax.to(
                                this.motSt[i].$panel[j].querySelector('.js__panel__inner'),
                                1.6,
                                {
                                    scale: 1,
                                    ease: Power2.easeOut,
                                    delay: 0.4,
                                }
                            )
                            TweenMax.to(
                                this.motSt[i].$panel[j].querySelector('.js__panel__inner'),
                                0.8,
                                {
                                    opacity: 1,
                                    ease: Power2.easeOut,
                                    delay: 0.3,
                                }
                            )
                        }
                    }
                    if (this.motSt[i].$split[0]) {
                        for (let j in this.motSt[i].$split[0].children) {
                            this.effect.split(
                                this.motSt[i].$split[0].children[j].children,
                                'show'
                            )
                        }
                    }
                    if (this.motSt[i].$fade[0]) {
                        for (let j in this.motSt[i].$fade) {
                            let _delay = this.motSt[i].$fade[j].getAttribute('data-delay');
                            TweenMax.to(
                                this.motSt[i].$fade[j],
                                1.2,
                                {
                                    delay: _delay,
                                    opacity: 1,
                                    ease: Power3.easeOut,
                                }
                            )
                        }
                    }
                }
            }, 1e1)
        }

        this.kv.flg = pageID == 'top' ? true : false
    }
    scroll(inc,dir) {
        for (let i in this.point) {
            if (this.status.naviCurrent <= i && this.point[i].start <= inc && dir=="next" || this.status.naviCurrent >= i && this.point[i].end > inc && dir=="prev") {


                this.status.naviCurrent = i

                if(this.status.naviPrevCurrent != this.status.naviCurrent){
                    for (let j in this.point) {
                        if(this.$navi[j]){
                            this.$navi[j].classList.remove("is-current")
                        }
                    }
                    if(dir == 'prev'){
                        if(this.$navi[this.status.naviCurrent-1]) this.$navi[this.status.naviCurrent-1].classList.add("is-current")
                        // if(this.$navi[this.status.naviPrevCurrent]) this.$navi[this.status.naviPrevCurrent].classList.remove("is-current")
                    }else{
                        if(this.$navi[this.status.naviCurrent-1]) this.$navi[this.status.naviCurrent-1].classList.add("is-current")
                        // if(this.$navi[this.status.naviPrevCurrent-1]) this.$navi[this.status.naviPrevCurrent-1].classList.remove("is-current")
                    }
                // }else if(this.status.naviPrevCurrent==0){
                //     console.log("reset")
                //     for (let j in this.point) {
                //         if(this.$navi[j]){
                //             this.$navi[j].classList.remove("is-current")
                //         }
                //     }
                }

                this.status.naviPrevCurrent = this.status.naviCurrent

            }
        }

    }
    mot(inc,mouse,comp){
        for (let i in this.motSt) {
            if (this.status.current <= i && this.motSt[i].posi.start < inc) {
                this.status.current = i
                if (!this.motSt[i].show) {
                    this.motSt[i].show = true
                    this.motSt[i].func()
                }
            }
            if(this.endPoint<inc){
                if (!this.motSt[i].show) {
                    this.motSt[i].show = true
                    this.motSt[i].func()
                }
            }
        }



        if (this.kv.flg) {

            if (window.innerHeight/2 < inc) {
                if(mouse) {
                    if(mouse.status.fixedCircle){
                        mouse.status.fixedCircle=false
                        mouse.motion.opOut(mouse.$fixCircle)
                        mouse.maskOut()
                    }
                }
            }else{
                if(mouse) {
                    if(!mouse.status.fixedCircle){
                        mouse.status.fixedCircle=true
                        mouse.motion.opShow(mouse.$fixCircle)
                        mouse.maskShow()
                    }
                }
            }

            // スクロールダウンの表示処理
            if (window.innerHeight < inc) {
                if (this.kv.show) {
                    TweenMax.killTweensOf([this.$scrollDown,this.$copyright], {
                        opacity: true,
                        y: true,
                    })
                    TweenMax.to([this.$scrollDown,this.$copyright], 0.2, {
                        opacity: 0,
                        y: -20,
                    })
                }
                this.kv.show = false

            } else {
                // this.webgl.status.pause = true
                if (!this.kv.show) {
                    TweenMax.to([this.$scrollDown,this.$copyright], 0.2, {
                        opacity: 1,
                        y: 0,
                    })
                }
                this.kv.show = true



            }
        }

        if(inc > Number(this.manager.bodyHeight - window.innerHeight - 200)){
            if(!this.sns) return;
            this.sns = false;
            TweenMax.to('.share', 0.2, {
                opacity: 0,
            })
        }else{
            if(this.sns) return;
            this.sns = true;
            TweenMax.to('.share', 0.2, {
                opacity: 1,
            })
        }

        // if (Useragnt.pc) {
        //     if (this.endPoint <= inc) {
        //         //ページトップの表示処理(PCのみ)
        //
        //         if (!this.status.pagetop) {
        //             TweenMax.to(this.$pageTop, 0.2, {
        //                 opacity: 1,
        //                 y: 0,
        //             })
        //         }
        //         this.status.pagetop = true
        //     } else {
        //         if (!this.status.pagetop) {
        //             TweenMax.killTweensOf(this.$pageTop, {
        //                 opacity: true,
        //                 y: true,
        //             })
        //             TweenMax.to(this.$pageTop, 0.2, {
        //                 opacity: 0,
        //                 y: 20,
        //             })
        //         }
        //         this.status.pagetop = false
        //     }
        // }
    }
    resize(winH, bodyH, inc) {
        for (let i in this.motSt) {
            let _rect = this.$point[i].getBoundingClientRect()

            this.motSt[i].posi = {
                base: _rect.top + inc,
                start: Math.max(_rect.top + inc - winH/2, i * 10),
                end: Math.max(_rect.top + inc + _rect.height + winH / 2, winH),
            }
        }

        for (let i in this.$naviPoint) {
            if (this.$naviPoint[i].nodeType != 1) break

            let _rect = this.$naviPoint[i].getBoundingClientRect()

            this.point[i] = {
                base: _rect.top + inc,
                start: Math.max(_rect.top + inc - winH/2, i * 10),
                end: Math.max(_rect.top + inc + _rect.height - winH/2, winH),
            }
        }

        // console.log(this.point)

        this.endPoint = bodyH - winH * 1.1
    }
}